import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';
import te from './locales/te.json';
import mr from './locales/mr.json';
import bn from './locales/bn.json';
import kn from './locales/kn.json';
import gu from './locales/gu.json';
import ml from './locales/ml.json';

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  ta: { translation: ta },
  te: { translation: te },
  mr: { translation: mr },
  bn: { translation: bn },
  kn: { translation: kn },
  gu: { translation: gu },
  ml: { translation: ml },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Persist language choice to localStorage whenever it changes so the
// selection survives page reload without depending on i18next-browser-languagedetector.
i18n.on('languageChanged', (lang: string) => {
  localStorage.setItem('language', lang);
});

export default i18n;